export default "__VITE_ASSET__BxTk1SGE__"